var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtcIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99967 4.66683V7.3335M11.9997 4.66683V7.3335M1.33301 3.46683L1.33301 8.5335C1.33301 9.28023 1.33301 9.6536 1.47833 9.93882C1.60616 10.1897 1.81014 10.3937 2.06102 10.5215C2.34624 10.6668 2.7196 10.6668 3.46634 10.6668L12.533 10.6668C13.2797 10.6668 13.6531 10.6668 13.9383 10.5215C14.1892 10.3937 14.3932 10.1897 14.521 9.93882C14.6663 9.6536 14.6663 9.28023 14.6663 8.5335V3.46683C14.6663 2.72009 14.6663 2.34673 14.521 2.06151C14.3932 1.81063 14.1892 1.60665 13.9383 1.47882C13.6531 1.3335 13.2797 1.3335 12.533 1.3335L3.46634 1.3335C2.7196 1.3335 2.34624 1.3335 2.06102 1.47882C1.81014 1.60665 1.60616 1.81063 1.47833 2.06151C1.33301 2.34672 1.33301 2.72009 1.33301 3.46683ZM9.66634 6.00016C9.66634 6.92064 8.92015 7.66683 7.99967 7.66683C7.0792 7.66683 6.33301 6.92064 6.33301 6.00016C6.33301 5.07969 7.0792 4.3335 7.99967 4.3335C8.92015 4.3335 9.66634 5.07969 9.66634 6.00016Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtcIcon);
export default __webpack_public_path__ + "static/media/ctcIcon.2687e13dce7e6d7172d3959e57919deb.svg";
export { ForwardRef as ReactComponent };